module.exports = __webpack_public_path__ + "img/JC-colombia-horizontal.7a45fdac.png";